export enum UserLoginStatus {
  ACTIVE = 0,
  IDLE = 1,
  NOT_LOGGED_IN = 2,
}
